import '../paedml-icon.tag'
import '../paedml-form-input.tag'
import '../paedml-modal.tag'

<paedml-modal-computer-installations>
  <paedml-modal prefix={opts.prefix} heading={heading} opname={opts.opname} edit={true}
                selectedrowsfunc={opts.selectedrowsfunc} idcol="{opts.idcol || 0}" idtextcol="{opts.idtextcol || 1}"
                submitfunc={submitHandler} patient={patient} large={true}
                cancelbutton={true} okcondition={okcondition} >

    <yield to="fields">
      <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
          <p class="my-auto">Liste der Softwarepakete wird aktualisiert...</p>
          <div class="sk-wave">
            <div class="sk-rect sk-rect1"></div>
            <div class="sk-rect sk-rect2"></div>
            <div class="sk-rect sk-rect3"></div>
            <div class="sk-rect sk-rect4"></div>
            <div class="sk-rect sk-rect5"></div>
          </div>
        </div>

      <div class="d-flex" show={!parent.loading}>
        <div style="width: 45%;">
          <div class="row">
            <div class="col-md-12">
              <strong>Nicht installiert / wird deinstalliert</strong>
            </div>
          </div>
          <table id="{opts.prefix}-source-modal-table" class="table table-striped table-hover"></table>
          <div if={parent.data.warningSource} class="mt-2 mr-1 p-2 border border-danger">
            <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" /> <strong class="text-danger pl-1 pt-2">{parent.data.warningSource}</strong> </span>
          </div>
        </div>
        <div style="width: 10%;">
          <div class="d-flex justify-content-center pt-5 mt-5">
            <paedml-icon icon="fas-long-arrow-alt-right" inv={true} title="Ausgewählte(n) Software installieren" onclick={parent.moveSource} />
          </div>
          <div class="d-flex justify-content-center">
            <paedml-icon icon="fas-long-arrow-alt-left" inv={true} title="Ausgewählte(n) Software deinstallieren" onclick={parent.moveTarget} />
          </div>
        </div>
        <div style="width: 45%;">
          <div class="row">
            <div class="col-md-12">
              <strong>Installiert / wird installiert</strong>
            </div>
          </div>
          <table id="{opts.prefix}-target-modal-table" class="table table-striped table-hover"></table>
          <div if={parent.data.warningTarget} class="mt-2 mr-1 p-2 border border-danger">
            <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" /> <strong class="text-danger pl-1 pt-2">{parent.data.warningTarget}</strong> </span>
          </div>
        </div>
      </div>
      <div class="paedml-input-group p-0 mt-3" show={!parent.loading}/>
        <div class="row">
          <div class="col-sm-3">
            <label class="py-2">
              <paedml-icon icon="fas-minus-circle" inv="true" class="pr-1"/>Wird deinstalliert
            </label>
          </div>
          <div class="col-sm-3">
            <paedml-form-input name="updateVersion" placeholder="Wird aktualisiert" fgclass="py-2"
                type="checkbox" revlut="jaNein" icon="fas-exclamation-circle"/>
          </div>
          <div class="col-sm-3">
            <paedml-form-input name="reinstall" placeholder="Wird nochmal installiert" fgclass="py-2"
                type="checkbox" revlut="jaNein" icon="fas-check-circle" />
          </div>
          <div class="col-sm-3">
            <label class="py-2">
              <paedml-icon icon="fas-plus-circle" inv="true" class="pr-1"/>Wird installiert
            </label>
          </div>
        </div>
      </div>
    </yield>
  </paedml-modal>

  <script>
    import * as i18n from '../../config/i18n/german'
    import * as R from 'ramda'
    import { toTrueMap } from '../../util/mapping-util'
    import API from '../../api'
    import { patientFormatter, handleSubmitEdit } from '../../util/api-util'
    import Session from '../../store/session'
    
    this.op = opts.op
    this.prefix = opts.prefix
    this.variant = opts.variant
    this.data = { }
    this.patient = opts.patient 
    this.data.updateVersion = false
    this.data.reinstall = false
    
    this.okcondition = () => !(this.data.warningSource || this.data.warningTarget)
    this.heading = this.opts.heading

    this.on('update', () => {
      this.loading = false
      this.heading = this.data.computer === undefined ? this.opts.heading : `${this.data.computer[1]}: Installation verwalten`
    })

    this.moveSource = () => {
      const from = this.tableSource
      const to = this.tableTarget
      const selected = from.rows( { selected: true } )
      const selectedRows = selected.data()
      const targetRow = to.row
     
      selectedRows.each((e, i) => {
        
        const installedSoftware = { 
          id: e.id,
          name: e.name,
          version: e.version,
          softwareVersion: e.version,
          icon: 'fas-plus-circle'
        }
        targetRow.add(installedSoftware)
      })
      selected.remove()

      this.redrawTables()

      $('input[type=search]').val('').trigger('keyup')
      $('select[ref=input]').val(' ').trigger('change')
    }

    this.moveTarget = () => {
      const from = this.tableTarget
      const to = this.tableSource
      const selected = from.rows( { selected: true } )
      const selectedRows = selected.data()
      
      const targetRow = to.row
     
      selectedRows.each((e, i) => {
        const softwareProduct = this.data.softwareProducts[e.id]
        targetRow.add(this.mapSourceSoftware(softwareProduct, 'fas-minus-circle'))
      })
      selected.remove()

      this.redrawTables()

      $('input[type=search]').val('').trigger('keyup')
      $('select[ref=input]').val(' ').trigger('change')

    }

    this.mapSourceSoftware = (e, icon) => ({ 
      id: e.id,
      icon: icon,
      name: e.name,
      version: `${e.productVersion}-${e.packageVersion}`
    })

    this.mapTargetSoftware = (e) => ({ 
      id: e.softwareProduct.id,
      name: e.softwareProduct.name,
      version: `${e.productVersion}-${e.packageVersion}`,
      softwareVersion: `${e.softwareProduct.productVersion}-${e.softwareProduct.packageVersion}`,
      icon: this.isOldVersion(`${e.softwareProduct.productVersion}-${e.softwareProduct.packageVersion}`, `${e.productVersion}-${e.packageVersion}`) ? 'fas-exclamation-circle' : 'fas-check-circle'
    })

    this.isOldVersion = (software, installed) => {
      return software !== installed
    }

    this.getTableSource = () => this.tableSource
    this.getTableTarget = () => this.tableTarget

    this.getIcon = (icon) => {
      let title = ''
      switch (icon) {
        case "fas-plus-circle": title = "Softwarepaket wird installiert."; break;
        case "fas-minus-circle": title = "Softwarepaket wird deinstalliert."; break;
        case "fas-exclamation-circle": title = "Softwarepaket ist installiert. Version ist veraltet."; break;
        case "fas-check-circle": title = "Softwarepaket ist installiert. Version ist aktuell."; break;
        default: title = ''; break
      }
      return `<span title="${title}"><svg class="paedml-icon black" style="margin-top: -3px"><use xlink:href="#${icon}" /></svg></span>`
    }

    this.refreshSoftwareGrids = (installed) => {
      this.loading = true
      API.software.getAll().then(rsp => {
        this.loading = false
        const [softwareProducts, status] = rsp
               
        this.data.softwareProducts = softwareProducts.reduce((acc, e) => {
          acc[e.id] = e
          return acc
        }, {})

        const exIds = {}
        const targetList = installed.map(e => {
          const id = e.softwareProduct.id
          exIds[id] = true
          const access = this.data.softwareProducts[id]
          return this.mapTargetSoftware(e, access === undefined)
        })

        const softwareProductsList = softwareProducts.filter(e => !exIds[e.id]).map(e => this.mapSourceSoftware(e, ''))
        const selector = `#${opts.prefix}-source-modal-table`
        this.tableSource = $(selector).DataTable( {
          data: softwareProductsList,
          columns: [
            { data: 'id', title: 'id', visible: false, searchable: false },
            { data: 'icon', title: '', fnCreatedCell: (td, val) => val ? $(td).html(this.getIcon(val)) : '', priority: 1 },
            { data: 'name', title: 'Softwarepaket' },
            { data: 'version', title: 'Version' },
          ],
          paging: false,
          scrollY: 400,
          lengthChange: false,
          select: {
              style: 'multi+shift'
          },
          info: true,
          order: [[ 2, 'asc' ]],
          oLanguage: i18n.short,
          infoCallback: ( settings, start, end, max, total, pre ) => {
            const dt = this.getTableSource()
            if (dt) {
              const selected = dt.rows({selected: true}).data().length
              const selectionOnThisPage = dt.rows({selected: true, page:'current'}).data().length
              const hidden = selected - selectionOnThisPage
              if (hidden !== 0) {
                if (hidden === 1) {
                  this.data.warningSource = 'Aktueller Filter verdeckt einen ausgewählten Eintrag!'
                } else {
                  this.data.warningSource = `Aktueller Filter verdeckt ${hidden} ausgewählte Einträge!`
                }
              } else {
                if (settings.aiDisplay.length !== settings.aiDisplayMaster.length) {
                  this.data.warningSource = 'Bitte setzen Sie den Filter zurück, um die Änderungen übernehmen zu können'
                } else {
                  this.data.warningSource = ''
                }
              }
              this.update()
            }
            return pre
          }
        } )
        const sourceNode = $(selector + '_wrapper > div:nth-child(1) > div:nth-child(1)')
          .removeClass('col-md-6')
          .addClass('col-md-12 col-lg-5')
        $(selector + '_wrapper > div:nth-child(1) > div:nth-child(2)')
          .removeClass('col-md-6')
          .addClass('col-md-12 col-lg-7 col-xl-7')

        const selectorTarget = `#${opts.prefix}-target-modal-table`
        this.tableTarget = $(selectorTarget).DataTable( {
          data: targetList,
          columns: [
            { data: 'icon', title: '', fnCreatedCell: (td, val) => val ? $(td).html(this.getIcon(val)) : '', priority: 1},
            { data: 'id', title: 'id', visible: false, searchable: false },
            { data: 'name', title: 'Softwarepaket' },
            { data: 'softwareVersion', title: 'softwareVersion', visible: false, searchable: false },
            { data: 'version', title: 'Version' },
          ],
          paging: false,
          scrollY: 400,
          lengthChange: false,
          select: {
              style: 'multi+shift'
          },
          info: true,
          order: [[ 2, 'asc']],
          oLanguage: i18n.short,
          infoCallback: ( settings, start, end, max, total, pre ) => {
            const dt = this.getTableTarget()
            if (dt) {
              const selected = dt.rows({selected: true}).data().length
              const selectionOnThisPage = dt.rows({selected: true, page:'current'}).data().length
              const hidden = selected - selectionOnThisPage
              if (hidden !== 0) {
                if (hidden === 1) {
                  this.data.warningTarget = 'Aktueller Filter verdeckt einen ausgewählten Eintrag!'
                } else {
                  this.data.warningTarget = `Aktueller Filter verdeckt ${hidden} ausgewählte Einträge!`
                }
              } else {
                if (settings.aiDisplay.length !== settings.aiDisplayMaster.length) {
                  this.data.warningTarget = 'Bitte setzen Sie den Filter zurück, um die Änderungen übernehmen zu können'
                } else {
                  this.data.warningTarget = ''
                }
              }
              this.update()
            }
            return pre
          }
        } )
        const targetNode = $(selectorTarget + '_wrapper > div:nth-child(1) > div:nth-child(1)')
          .removeClass('col-md-6')
          .addClass('col-md-12 col-lg-5')
        $(selectorTarget + '_wrapper > div:nth-child(1) > div:nth-child(2)')
          .removeClass('col-md-6')
          .addClass('col-md-12 col-lg-6 col-xl-7')
        
        this.update()
      })
    }

    this.redrawTables = () => {
      if (this.tableSource) this.tableSource.draw()
      if (this.tableTarget) this.tableTarget.draw()
    }

    this.on('hide', () => {
      if (this.tableSource) this.tableSource.destroy()
      this.tableSource = null
      if (this.tableTarget) this.tableTarget.destroy()
      this.tableTarget = null
    })

    this.on('shown', ()=> {
      this.redrawTables()
    })

    this.on('rowMappingRequested', (cols) => {
      this.loading = true
      this.data.computer = cols
      API.software.computers.installations.get(cols[0]).then(rsp => {

        this.loading = false
        const [installed, status] = rsp
        if (status.error) {
          this.update()
        }
        this.data.installed = installed
        
        this.update()
        this.refreshSoftwareGrids(installed)
      })
    })

    this.submitHandler = formData => {
      if (formData.ids.length < 1) return Promise.resolve('Operation abgebrochen')

      const computerId = formData.ids[0]
      
      const install = []
      this.tableTarget.data().each(e => {
        install.push(e.id)
      })
      const uninstall = []
      this.tableSource.data().each(e => {
        uninstall.push(e.id)
      })
      const { updateVersion, reinstall } = formData
      return API.software.computers.installations.set(computerId, { install, uninstall, updateVersion, reinstall }).then(rsp => {
        return handleSubmitEdit(this, rsp, undefined, undefined, true)
      })
    }

  </script>
</paedml-modal-computer-installations>
